import { post } from ".";

export function CreateIntegrationCampaignCustomerAssociation(options = {}) {
    return post<any>("/app/api/integration_campaign_customer_association", options);
}